(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[940],{

/***/ 789:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/browser.4a175c61.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAXUlEQVR42j2NMQ5AQBREB71o3EI2kRUUSHABrUYo9/79i6k2kz8vr/kjXiY2VhZ2LpJ46JgYiMy+T/QoxyYGI9E6CZuIxklN47aJ0agsByU2EYwi/wjiJuANojtw/wH0SbxFTrQ+AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 5751:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/left-chevron.0d73fd01.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAANElEQVR42mOAgH/MYJIRxmUBYud/7kCSCSr7z+Ffzz82kBqw2D/7f20wLRgCGFowDMWwFgAKPyIpYPjBrwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 8464:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/right-chevron.0fa3d555.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAPElEQVR42mNgYPjHyAAE/5gZIOAfExC7/XMGkiwQAUYgZv3X888Rqgqupe2fPUQ9ugC6Foih7kiGolsLADYGIii2z4qMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);





var Page = function(param) {
    var meta = param.meta, jsonLd = param.jsonLd, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    //! Url
    var url = "https://handle.am" + router.asPath;
    //! Title
    var title = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (meta === null || meta === void 0 ? void 0 : meta.title) || "Handle Brand Armenia";
    }, [
        meta === null || meta === void 0 ? void 0 : meta.title
    ]);
    //! Description
    var description = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (meta === null || meta === void 0 ? void 0 : meta.description) || "Handle Brand Armenia";
    }, [
        meta === null || meta === void 0 ? void 0 : meta.description
    ]);
    //! Image
    var image = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            url: (meta === null || meta === void 0 ? void 0 : meta.image) || "https://handle.am" + "/handle-logo.png",
            alt: title
        };
    }, [
        meta === null || meta === void 0 ? void 0 : meta.image
    ]);
    //! Ld Json
    var ldJson = jsonLd || {
        "@context": "http://schema.org/",
        "@type": "Organization",
        name: "Handle Brand Armenia",
        address: {
            "@type": "PostalAddress",
            streetAddress: "Yerevan, Buzand 1/3",
            addressLocality: "Yerevan",
            addressRegion: "Yerevan"
        },
        telephone: "+374 33 58 58 50"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                canonical: url,
                type: "website",
                openGraph: {
                    url: url,
                    title: title,
                    description: description,
                    images: [
                        image
                    ]
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson)
                    }
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);




var Banner = function(param) {
    var title = param.title, currentPage = param.currentPage;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var goHome = function() {
        router.push("/");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "banner",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "banner-content",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "banner-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "breadcrumbs",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "#",
                                    onClick: goHome,
                                    children: intl.messages.home
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: currentPage
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 9070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ productItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/assets/images/icons/add-to-cart.png
/* harmony default export */ var add_to_cart = ({"src":"/_next/static/media/add-to-cart.72803f29.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAbUlEQVR42g3EIQ5BcQAH4F/AVMkJFFMpdNMEQbJJzEZAEJzBBYzgFC+9OYJ3oW/++7YvIjbeXuVIdMzVJkVtrhNbjcqtqDS2cXAyFTFztI+LpegWsXaPs5Voa4m+UVwtRGHoqRc7Xw8fJ2M/gz9GP1Mdk9tBnQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/icons/added-to-cart.png
/* harmony default export */ var added_to_cart = ({"src":"/_next/static/media/added-to-cart.d54ddace.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAcklEQVR42h3NP8oBAAAH0N/69Y1GgwxiIya5gs2kDE6gLHaT2AxOYlDyd5EoGXGYl9I7wIuNo72ti7moxEdVQ1Pbn75H7BTlp+fuP9YmtmLgqaMWV7HwchNjyziLGCqIkWm8NbSU1JWtzGJjb+fk8Ku7X+TWWnrsh0F0AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/redux/global.slice.js
var global_slice = __webpack_require__(66);
// EXTERNAL MODULE: ./src/api/api.js + 1 modules
var api = __webpack_require__(977);
// EXTERNAL MODULE: ./src/helpers/basket.helper.js
var basket_helper = __webpack_require__(8769);
// EXTERNAL MODULE: ./src/helpers/cookie.helpers.js
var cookie_helpers = __webpack_require__(2881);
;// CONCATENATED MODULE: ./src/components/productItem.js














var ProductItem = function(param) {
    var image = param.image, name = param.name, code = param.code, size = param.size, price = param.price, tag = param.tag, oldPriceData = param.oldPriceData, id = param.id, currency = param.currency, changeSize = param.changeSize, minPrice = param.minPrice, maxPrice = param.maxPrice;
    var ref, ref1;
    var ref2 = (0,react.useState)(null), sizeState = ref2[0], setSizeState = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,react.useState)(null), basketData = ref3[0], setBasketData = ref3[1];
    var intl = (0,useIntl/* default */.Z)();
    var priceData = price * tag;
    var priceOld = Math.round(priceData / 100);
    var newPrice = price - priceOld;
    var basket = (0,es/* useSelector */.v9)(function(state) {
        return state.global.basket;
    });
    var basketDataReq = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var basketReq, data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api/* basket_req */.Cl)(basket)
                        ];
                    case 1:
                        basketReq = _state.sent();
                        setBasketData(basketReq);
                        data = (0,cookie_helpers/* getCookie */.ej)("basket");
                        if (basketReq) {
                            dispatch((0,global_slice/* changeBasketCount */.zW)(data === null || data === void 0 ? void 0 : data.length));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function basketDataReq() {
            return _ref.apply(this, arguments);
        };
    }();
    var addBasket = function() {
        basketDataReq();
        (0,basket_helper/* addRemoveFromBasket */.cQ)(id, 1, intl.messages.product_successfully_added, intl.messages.product_successfully_removed);
    // const dataFilter = basketData?.find((item) => item.id === id);
    };
    (0,react.useEffect)(function() {
        if (typeof size === "string") {
            setSizeState(JSON.parse(size ? size : null));
        } else {
            setSizeState(size);
        }
    }, [
        size
    ]);
    var defaultImage = "https://via.placeholder.com/1000x1000/f3f3f3/f3f3f3/?text=.";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-item mb-40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-image",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: ("/product?id=".concat(id, "&changeSize=").concat(changeSize, "&minPrice=").concat(minPrice, "&maxPrice=").concat(maxPrice), "/product?id=".concat(id)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image,
                                    alt: name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: defaultImage,
                                    alt: name
                                }),
                                tag > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "tag",
                                    children: [
                                        "-",
                                        tag,
                                        "%"
                                    ]
                                })
                            ]
                        })
                    }),
                    !basketData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "cart-button",
                        onClick: addBasket,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: intl.messages.addBasket
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: add_to_cart.src,
                                alt: "Add To Cart"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cart-button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: intl.messages.productAdded
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: added_to_cart.src,
                                alt: ""
                            })
                        ]
                    })
                ]
            }),
            name && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                className: "product-name mb-10",
                href: ("/product?id=".concat(id, "&changeSize=").concat(changeSize, "&minPrice=").concat(minPrice, "&maxPrice=").concat(maxPrice), "/product?id=".concat(id)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "product-name",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-ai-end flex-jc-between p-20 pl-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "product-info",
                            children: [
                                code && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        intl.messages.code,
                                        ": ",
                                        code
                                    ]
                                }),
                                (sizeState === null || sizeState === void 0 ? void 0 : (ref = sizeState[0]) === null || ref === void 0 ? void 0 : ref.name) || (sizeState === null || sizeState === void 0 ? void 0 : sizeState.name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        intl.messages.size,
                                        ": ",
                                        (sizeState === null || sizeState === void 0 ? void 0 : (ref1 = sizeState[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || (sizeState === null || sizeState === void 0 ? void 0 : sizeState.name)
                                    ]
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-prices",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-price",
                                children: [
                                    tag ? newPrice : price,
                                    " ",
                                    currency
                                ]
                            }),
                            oldPriceData && price && tag > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-oldPrice",
                                children: [
                                    price,
                                    " ",
                                    currency
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var productItem = (ProductItem);


/***/ }),

/***/ 1810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var SelectCustom = function(param) {
    var label = param.label, handleChange = param.handleChange, name = param.name, value = param.value, children = param.children, minText = param.minText, id = param.id, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "field-item ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                name: name,
                onChange: handleChange,
                value: value,
                id: id,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                children: minText
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectCustom);


/***/ }),

/***/ 8769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EG": function() { return /* binding */ incrementProduct; },
/* harmony export */   "Zg": function() { return /* binding */ decrementProduct; },
/* harmony export */   "cQ": function() { return /* binding */ addRemoveFromBasket; }
/* harmony export */ });
/* unused harmony export changeCountForProduct */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7582);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(977);
/* harmony import */ var _cookie_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2881);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2920);







function addRemoveFromBasket(id, count, addMessage, removeMessage) {
    var existingBasket = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("basket");
    if (!existingBasket) {
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify([
            id
        ]));
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, id, count)));
        react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(addMessage);
        return;
    }
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    try {
        existingBasket = JSON.parse(existingBasket);
        productsCount = JSON.parse(productsCount);
        var indexInBasket = existingBasket.indexOf(id);
        if (indexInBasket === -1) {
            productsCount[id] = count;
            existingBasket.push(id);
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify(existingBasket));
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
            react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(addMessage);
        } else {
            if (existingBasket.length === 1) {
                var basketDataReq = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        var basketReq, data, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        (0,_api_api__WEBPACK_IMPORTED_MODULE_0__/* .basket_req */ .Cl)(existingBasket)
                                    ];
                                case 1:
                                    basketReq = _state.sent();
                                    data = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("basket");
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    e = _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function basketDataReq() {
                        return _ref.apply(this, arguments);
                    };
                }();
                basketDataReq();
                react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(removeMessage);
                (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
                (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
                window.location.reload();
                return;
            }
            delete productsCount[id];
            existingBasket.splice(indexInBasket, 1);
            react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(removeMessage);
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify(existingBasket));
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
        }
    } catch (e) {
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
function incrementProduct(id) {
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    if (!productsCount) {
        return;
    }
    try {
        productsCount = JSON.parse(productsCount);
        productsCount[id]++;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
    } catch (e) {
        ;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
function decrementProduct(id) {
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    if (!productsCount) {
        return;
    }
    try {
        productsCount = JSON.parse(productsCount);
        productsCount[id]--;
        if (productsCount[id] === 0) {
            delete productsCount[id];
        }
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
    } catch (e) {
        ;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
var changeCountForProduct = function() {
    var countObj = _object_spread({}, state.productsCount);
    countObj[action.payload.productId] = action.payload.count;
    setCookie("productsCount", JSON.stringify(countObj));
    state.productsCount = countObj;
};


/***/ }),

/***/ 1358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,a){ true?module.exports=a(__webpack_require__(7294)):0}(this,(e=>(()=>{var a={703:(e,a,t)=>{"use strict";var r=t(414);function n(){}function i(){}i.resetWarningCache=n,e.exports=function(){function e(e,a,t,n,i,s){if(s!==r){var o=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw o.name="Invariant Violation",o}}function a(){return e}e.isRequired=e;var t={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:a,element:e,elementType:e,instanceOf:a,node:e,objectOf:a,oneOf:a,oneOfType:a,shape:a,exact:a,checkPropTypes:i,resetWarningCache:n};return t.PropTypes=t,t}},697:(e,a,t)=>{e.exports=t(703)()},414:e=>{"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},98:a=>{"use strict";a.exports=e}},t={};function r(e){var n=t[e];if(void 0!==n)return n.exports;var i=t[e]={exports:{}};return a[e](i,i.exports,r),i.exports}r.n=e=>{var a=e&&e.__esModule?()=>e.default:()=>e;return r.d(a,{a}),a},r.d=(e,a)=>{for(var t in a)r.o(a,t)&&!r.o(e,t)&&Object.defineProperty(e,t,{enumerable:!0,get:a[t]})},r.o=(e,a)=>Object.prototype.hasOwnProperty.call(e,a),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};return(()=>{"use strict";r.r(n),r.d(n,{default:()=>k});var e=r(98),a=r.n(e),t=r(697),i=r.n(t);function s(){return s=Object.assign?Object.assign.bind():function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},s.apply(this,arguments)}var o=function(e){var t=e.pageClassName,r=e.pageLinkClassName,n=e.page,i=e.selected,o=e.activeClassName,l=e.activeLinkClassName,c=e.getEventListener,p=e.pageSelectedHandler,u=e.href,g=e.extraAriaContext,d=e.pageLabelBuilder,f=e.rel,b=e.ariaLabel||"Page "+n+(g?" "+g:""),v=null;return i&&(v="page",b=e.ariaLabel||"Page "+n+" is your current page",t=void 0!==t?t+" "+o:o,void 0!==r?void 0!==l&&(r=r+" "+l):r=l),a().createElement("li",{className:t},a().createElement("a",s({rel:f,role:u?void 0:"button",className:r,href:u,tabIndex:i?"-1":"0","aria-label":b,"aria-current":v,onKeyPress:p},c(p)),d(n)))};o.propTypes={pageSelectedHandler:i().func.isRequired,selected:i().bool.isRequired,pageClassName:i().string,pageLinkClassName:i().string,activeClassName:i().string,activeLinkClassName:i().string,extraAriaContext:i().string,href:i().string,ariaLabel:i().string,page:i().number.isRequired,getEventListener:i().func.isRequired,pageLabelBuilder:i().func.isRequired,rel:i().string};const l=o;function c(){return c=Object.assign?Object.assign.bind():function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},c.apply(this,arguments)}var p=function(e){var t=e.breakLabel,r=e.breakAriaLabel,n=e.breakClassName,i=e.breakLinkClassName,s=e.breakHandler,o=e.getEventListener,l=n||"break";return a().createElement("li",{className:l},a().createElement("a",c({className:i,role:"button",tabIndex:"0","aria-label":r,onKeyPress:s},o(s)),t))};p.propTypes={breakLabel:i().oneOfType([i().string,i().node]),breakAriaLabel:i().string,breakClassName:i().string,breakLinkClassName:i().string,breakHandler:i().func.isRequired,getEventListener:i().func.isRequired};const u=p;function g(e){var a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return null!=e?e:a}function d(e){return d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},d(e)}function f(){return f=Object.assign?Object.assign.bind():function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},f.apply(this,arguments)}function b(e,a){for(var t=0;t<a.length;t++){var r=a[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function v(e,a){return v=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,a){return e.__proto__=a,e},v(e,a)}function h(e,a){if(a&&("object"===d(a)||"function"==typeof a))return a;if(void 0!==a)throw new TypeError("Derived constructors may only return object or undefined");return m(e)}function m(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function y(e){return y=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},y(e)}function C(e,a,t){return a in e?Object.defineProperty(e,a,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[a]=t,e}var P=function(e){!function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),a&&v(e,a)}(o,e);var t,r,n,i,s=(n=o,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,a=y(n);if(i){var t=y(this).constructor;e=Reflect.construct(a,arguments,t)}else e=a.apply(this,arguments);return h(this,e)});function o(e){var t,r;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,o),C(m(t=s.call(this,e)),"handlePreviousPage",(function(e){var a=t.state.selected;t.handleClick(e,null,a>0?a-1:void 0,{isPrevious:!0})})),C(m(t),"handleNextPage",(function(e){var a=t.state.selected,r=t.props.pageCount;t.handleClick(e,null,a<r-1?a+1:void 0,{isNext:!0})})),C(m(t),"handlePageSelected",(function(e,a){if(t.state.selected===e)return t.callActiveCallback(e),void t.handleClick(a,null,void 0,{isActive:!0});t.handleClick(a,null,e)})),C(m(t),"handlePageChange",(function(e){t.state.selected!==e&&(t.setState({selected:e}),t.callCallback(e))})),C(m(t),"getEventListener",(function(e){return C({},t.props.eventListener,e)})),C(m(t),"handleClick",(function(e,a,r){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},i=n.isPrevious,s=void 0!==i&&i,o=n.isNext,l=void 0!==o&&o,c=n.isBreak,p=void 0!==c&&c,u=n.isActive,g=void 0!==u&&u;e.preventDefault?e.preventDefault():e.returnValue=!1;var d=t.state.selected,f=t.props.onClick,b=r;if(f){var v=f({index:a,selected:d,nextSelectedPage:r,event:e,isPrevious:s,isNext:l,isBreak:p,isActive:g});if(!1===v)return;Number.isInteger(v)&&(b=v)}void 0!==b&&t.handlePageChange(b)})),C(m(t),"handleBreakClick",(function(e,a){var r=t.state.selected;t.handleClick(a,e,r<e?t.getForwardJump():t.getBackwardJump(),{isBreak:!0})})),C(m(t),"callCallback",(function(e){void 0!==t.props.onPageChange&&"function"==typeof t.props.onPageChange&&t.props.onPageChange({selected:e})})),C(m(t),"callActiveCallback",(function(e){void 0!==t.props.onPageActive&&"function"==typeof t.props.onPageActive&&t.props.onPageActive({selected:e})})),C(m(t),"getElementPageRel",(function(e){var a=t.state.selected,r=t.props,n=r.nextPageRel,i=r.prevPageRel,s=r.selectedPageRel;return a-1===e?i:a===e?s:a+1===e?n:void 0})),C(m(t),"pagination",(function(){var e=[],r=t.props,n=r.pageRangeDisplayed,i=r.pageCount,s=r.marginPagesDisplayed,o=r.breakLabel,l=r.breakClassName,c=r.breakLinkClassName,p=r.breakAriaLabels,g=t.state.selected;if(i<=n)for(var d=0;d<i;d++)e.push(t.getPageElement(d));else{var f=n/2,b=n-f;g>i-n/2?f=n-(b=i-g):g<n/2&&(b=n-(f=g));var v,h,m=function(e){return t.getPageElement(e)},y=[];for(v=0;v<i;v++){var C=v+1;if(C<=s)y.push({type:"page",index:v,display:m(v)});else if(C>i-s)y.push({type:"page",index:v,display:m(v)});else if(v>=g-f&&v<=g+(0===g&&n>1?b-1:b))y.push({type:"page",index:v,display:m(v)});else if(o&&y.length>0&&y[y.length-1].display!==h&&(n>0||s>0)){var P=v<g?p.backward:p.forward;h=a().createElement(u,{key:v,breakAriaLabel:P,breakLabel:o,breakClassName:l,breakLinkClassName:c,breakHandler:t.handleBreakClick.bind(null,v),getEventListener:t.getEventListener}),y.push({type:"break",index:v,display:h})}}y.forEach((function(a,t){var r=a;"break"===a.type&&y[t-1]&&"page"===y[t-1].type&&y[t+1]&&"page"===y[t+1].type&&y[t+1].index-y[t-1].index<=2&&(r={type:"page",index:a.index,display:m(a.index)}),e.push(r.display)}))}return e})),void 0!==e.initialPage&&void 0!==e.forcePage&&console.warn("(react-paginate): Both initialPage (".concat(e.initialPage,") and forcePage (").concat(e.forcePage,") props are provided, which is discouraged.")+" Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"),r=e.initialPage?e.initialPage:e.forcePage?e.forcePage:0,t.state={selected:r},t}return t=o,(r=[{key:"componentDidMount",value:function(){var e=this.props,a=e.initialPage,t=e.disableInitialCallback,r=e.extraAriaContext,n=e.pageCount,i=e.forcePage;void 0===a||t||this.callCallback(a),r&&console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."),Number.isInteger(n)||console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(n,"). Did you forget a Math.ceil()?")),void 0!==a&&a>n-1&&console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(a," > ").concat(n-1,").")),void 0!==i&&i>n-1&&console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(i," > ").concat(n-1,")."))}},{key:"componentDidUpdate",value:function(e){void 0!==this.props.forcePage&&this.props.forcePage!==e.forcePage&&(this.props.forcePage>this.props.pageCount-1&&console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage," > ").concat(this.props.pageCount-1,").")),this.setState({selected:this.props.forcePage})),Number.isInteger(e.pageCount)&&!Number.isInteger(this.props.pageCount)&&console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount,"). Did you forget a Math.ceil()?"))}},{key:"getForwardJump",value:function(){var e=this.state.selected,a=this.props,t=a.pageCount,r=e+a.pageRangeDisplayed;return r>=t?t-1:r}},{key:"getBackwardJump",value:function(){var e=this.state.selected-this.props.pageRangeDisplayed;return e<0?0:e}},{key:"getElementHref",value:function(e){var a=this.props,t=a.hrefBuilder,r=a.pageCount,n=a.hrefAllControls;if(t)return n||e>=0&&e<r?t(e+1,r,this.state.selected):void 0}},{key:"ariaLabelBuilder",value:function(e){var a=e===this.state.selected;if(this.props.ariaLabelBuilder&&e>=0&&e<this.props.pageCount){var t=this.props.ariaLabelBuilder(e+1,a);return this.props.extraAriaContext&&!a&&(t=t+" "+this.props.extraAriaContext),t}}},{key:"getPageElement",value:function(e){var t=this.state.selected,r=this.props,n=r.pageClassName,i=r.pageLinkClassName,s=r.activeClassName,o=r.activeLinkClassName,c=r.extraAriaContext,p=r.pageLabelBuilder;return a().createElement(l,{key:e,pageSelectedHandler:this.handlePageSelected.bind(null,e),selected:t===e,rel:this.getElementPageRel(e),pageClassName:n,pageLinkClassName:i,activeClassName:s,activeLinkClassName:o,extraAriaContext:c,href:this.getElementHref(e),ariaLabel:this.ariaLabelBuilder(e),page:e+1,pageLabelBuilder:p,getEventListener:this.getEventListener})}},{key:"render",value:function(){var e=this.props.renderOnZeroPageCount;if(0===this.props.pageCount&&void 0!==e)return e?e(this.props):e;var t=this.props,r=t.disabledClassName,n=t.disabledLinkClassName,i=t.pageCount,s=t.className,o=t.containerClassName,l=t.previousLabel,c=t.previousClassName,p=t.previousLinkClassName,u=t.previousAriaLabel,d=t.prevRel,b=t.nextLabel,v=t.nextClassName,h=t.nextLinkClassName,m=t.nextAriaLabel,y=t.nextRel,C=this.state.selected,P=0===C,k=C===i-1,x="".concat(g(c)).concat(P?" ".concat(g(r)):""),L="".concat(g(v)).concat(k?" ".concat(g(r)):""),N="".concat(g(p)).concat(P?" ".concat(g(n)):""),O="".concat(g(h)).concat(k?" ".concat(g(n)):""),R=P?"true":"false",E=k?"true":"false";return a().createElement("ul",{className:s||o,role:"navigation","aria-label":"Pagination"},a().createElement("li",{className:x},a().createElement("a",f({className:N,href:this.getElementHref(C-1),tabIndex:P?"-1":"0",role:"button",onKeyPress:this.handlePreviousPage,"aria-disabled":R,"aria-label":u,rel:d},this.getEventListener(this.handlePreviousPage)),l)),this.pagination(),a().createElement("li",{className:L},a().createElement("a",f({className:O,href:this.getElementHref(C+1),tabIndex:k?"-1":"0",role:"button",onKeyPress:this.handleNextPage,"aria-disabled":E,"aria-label":m,rel:y},this.getEventListener(this.handleNextPage)),b)))}}])&&b(t.prototype,r),Object.defineProperty(t,"prototype",{writable:!1}),o}(e.Component);C(P,"propTypes",{pageCount:i().number.isRequired,pageRangeDisplayed:i().number,marginPagesDisplayed:i().number,previousLabel:i().node,previousAriaLabel:i().string,prevPageRel:i().string,prevRel:i().string,nextLabel:i().node,nextAriaLabel:i().string,nextPageRel:i().string,nextRel:i().string,breakLabel:i().oneOfType([i().string,i().node]),breakAriaLabels:i().shape({forward:i().string,backward:i().string}),hrefBuilder:i().func,hrefAllControls:i().bool,onPageChange:i().func,onPageActive:i().func,onClick:i().func,initialPage:i().number,forcePage:i().number,disableInitialCallback:i().bool,containerClassName:i().string,className:i().string,pageClassName:i().string,pageLinkClassName:i().string,pageLabelBuilder:i().func,activeClassName:i().string,activeLinkClassName:i().string,previousClassName:i().string,nextClassName:i().string,previousLinkClassName:i().string,nextLinkClassName:i().string,disabledClassName:i().string,disabledLinkClassName:i().string,breakClassName:i().string,breakLinkClassName:i().string,extraAriaContext:i().string,ariaLabelBuilder:i().func,eventListener:i().string,renderOnZeroPageCount:i().func,selectedPageRel:i().string}),C(P,"defaultProps",{pageRangeDisplayed:2,marginPagesDisplayed:3,activeClassName:"selected",previousLabel:"Previous",previousClassName:"previous",previousAriaLabel:"Previous page",prevPageRel:"prev",prevRel:"prev",nextLabel:"Next",nextClassName:"next",nextAriaLabel:"Next page",nextPageRel:"next",nextRel:"next",breakLabel:"...",breakAriaLabels:{forward:"Jump forward",backward:"Jump backward"},disabledClassName:"disabled",disableInitialCallback:!1,pageLabelBuilder:function(e){return e},eventListener:"onClick",renderOnZeroPageCount:void 0,selectedPageRel:"canonical",hrefAllControls:!1});const k=P})(),n})()));
//# sourceMappingURL=react-paginate.js.map

/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

}]);